import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import NavLink from '../nav_link';

const styles = () => ({
    topic: {
        paddingLeft: '32px',
        maxHeight: '40px',
        paddingRight: '1.0rem',
    },
});

class JetListDeployment extends React.Component {
    render() {
        const { classes } = this.props;

        return (
            <React.Fragment>
                <Collapse component="li" in={this.props.isOpen} timeout="auto">
                    <List disablePadding>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/jet/deployment/guide"
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Deployment Guide" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/jet/deployment/jet-shared-storage"
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Using Shared Storage" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/jet/deployment/signiant-control"
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Testing with Signiant Control" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/jet/deployment/deployment-troubleshooting"
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Troubleshooting" />
                            </ListItem>
                        </NavLink>
                    </List>
                </Collapse>
            </React.Fragment>
        );
    }
}

JetListDeployment.propTypes = {
    classes: PropTypes.object.isRequired,
    isOpen: PropTypes.object,
    onActive: PropTypes.func,
    handleDrawerToggle: PropTypes.func,
};

export default withStyles(styles)(JetListDeployment);
